export default {
    name: 'clubs',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-club',
            component: () => import('@/modules/club/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-club',
            component: () => import('@/modules/club/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-club',
            component: () => import('@/modules/club/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}